var map = {
	"./0.png": "21f5",
	"./1.png": "7331",
	"./2.png": "0206",
	"./3.png": "e9cc",
	"./4.png": "7447",
	"./5.png": "3383",
	"./5_old.png": "9dc4",
	"./6.png": "6678",
	"./NS仙人白黒反転-assets/NS仙人白黒反転.png": "680f",
	"./NS仙人白黒反転.png": "8b83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1219";